import { customZOptionsParser } from './options-parser.js';
/**
 * @internal
 */
const defaultSimpleZOptions = {
    '--*': readAllZOptionValues,
    '-*': readAllZOptionValues,
    '*'(option) {
        option.values(0);
    },
};
/**
 * @internal
 */
function readAllZOptionValues(option) {
    option.values();
}
/**
 * Builds a simple command line options parser.
 *
 * @param config - Parser configuration.
 *
 * @returns New options parser.
 */
export function simpleZOptionsParser(config = {}) {
    const { options = defaultSimpleZOptions } = config;
    const parser = customZOptionsParser({
        ...config,
        options,
        optionClass(base) {
            class SimpleZOption extends base {
                constructor(recognized, ...args) {
                    super(...args);
                    this.whenRecognized(option => {
                        if (recognized[this.name]) {
                            recognized[this.name].push(...option.values());
                        }
                        else {
                            recognized[this.name] = [...option.values()];
                        }
                    });
                }
            }
            return SimpleZOption;
        },
    });
    return (args, fromIndex) => parser({}, args, fromIndex);
}
//# sourceMappingURL=simple-options-parser.js.map